<template>
  <div v-if="bookingData.book_parcel_model.Customer_ID > -1 && bookingData.book_parcel_model.Country_ID > -1 && bookingData.book_parcel_model.Service_Level_ID > -1">
    <div class="spl-book-general__counter">
      <div class="spl-book-general__counter__number">
        <form-label>Counter Number</form-label>
        <form-input
          v-if="!useShippingReference"
          :invalid="$v.counterNumber.$anyError"
          :value="counterNumber"
          :enable-trim="true"
          placeholder="Counter Number"
          data-cy="book-general-counter-number"
          @input="setCounterNumber" />
        <span v-if="$v.counterNumber.$anyError && !$v.counterNumber.required" class="error">Counter number required</span>
        <span v-if="!$v.counterNumber.backendValidated" class="error">Counter number not valid</span>
        <span v-if="!$v.counterNumber.minLength" class="error">Counter number must be minimum 5 characters</span>
        <div v-if="useShippingReference">
          {{ counterNumber }}
        </div>
      </div>
      <div class="spl-book-general__counter__scan">
        <form-label />
        <form-button
          v-if="showScan"
          @onClick="openScanner('counterNumber')">
          scan
        </form-button>
      </div>
      <div v-if="!useShippingReference" class="spl-book-general__counter__generate">
        <form-label />
        <form-button
          v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.GENERATE_COUNTER_NUMBER) && showGenerate"
          class="spl-book-general__generate-counter-number"
          data-cy="book-general-counter-number-generate"
          @onClick="generateNumber">
          Generate
        </form-button>
      </div>
    </div>
    <div v-if="isGenerating" class="spl-load-img" />
  </div>
</template>

<script>
import webApi from '@/webApi'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { minLength, required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'ParcelCounterNumber',
  mixins: [Helpers],
  props: ['bookingData', 'useShippingReference'],
  data () {
    return {
      counterNumber: '',
      isGenerating: false,
      constants,
      showScan: true,
      showGenerate: true
    }
  },
  watch: {
    bookingData: {
      handler: function (newVal) {
        var generatedCombination = this.bookingData.book_parcel_model.Customer_ID + '-' + this.bookingData.book_parcel_model.Country_ID + '-' + this.bookingData.book_parcel_model.Service_Level_ID
        if (this.generatedFor !== generatedCombination &&
            this.useShippingReference &&
            this.bookingData.book_parcel_model.Customer_ID > -1 &&
            this.bookingData.book_parcel_model.Country_ID > -1 &&
            this.bookingData.book_parcel_model.Service_Level_ID > -1) {
          this.generatedFor = generatedCombination
          this.generateNumber()
        }
      },
      deep: true
    }
  },
  validations: {
    counterNumber: {
      required,
      minLength: minLength(5),
      backendValidated (value) {
        if (this.useShippingReference || !value || (value && value.length < 5)) {
          return true
        }
        var promise = new Promise((resolve, reject) => {
          webApi.reference.check_Booking_Counternumber_is_Valid(this.bookingData.book_parcel_model)
            .then((response) => {
              if (response.data === true) {
                this.$emit('numberChanged', this.bookingData)
                resolve(true)
              } else {
                resolve(false)
              }
            })
            .catch((response) => {
              resolve(false)
              window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
            })
        })

        return promise
      }
    }
  },
  mounted () {
    this.$watch(vm => [vm.bookingData.book_parcel_model.Country_ID, vm.bookingData.book_parcel_model.Customer_ID, vm.bookingData.book_parcel_model.Is_Forward], val => {
      if (this.bookingData.book_parcel_model.Country_ID !== -1 && this.bookingData.book_parcel_model.Customer_ID !== -1) {
        this.getProfiler(this.bookingData.book_parcel_model.Customer_ID, this.bookingData.book_parcel_model.Country_ID, this.bookingData.book_parcel_model.Is_Forward)
      }
    },
    {
      immediate: true,
      deep: true
    })
  },
  methods: {
    ...mapActions('profiler', ['loadProfiler']),
    reset () {
      if (this.useShippingReference) {
        this.bookingData.book_parcel_model.Shipment_Reference = ''
        this.counterNumber = ''
        this.generateNumber()
      } else {
        this.bookingData.book_parcel_model.References[0].Reference_Text = ''
        this.counterNumber = ''
      }
    },
    getProfiler (customer_id, country_id, is_forward) {
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        this.profileData = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
        if (this.profileData !== null && this.profileData.Fields.length > 0) {
          const scan = this.profileData.Fields.find(el => el.Name === 'SCAN')
          const generate = this.profileData.Fields.find(el => el.Name === 'GENERATE')
          if (scan) {
            this.showScan = scan.Visible
          }
          if (generate) {
            this.showGenerate = generate.Visible
          }
        }
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    generateNumber () {
      this.isGenerating = true
      webApi.parcel.get_Counter_Number(this.bookingData.book_parcel_model)
        .then((response) => {
          // Get the  counter Number
          if (this.useShippingReference) {
            this.bookingData.book_parcel_model.Shipment_Reference = response.data
          } else {
            this.bookingData.book_parcel_model.References[0].Reference_Text = response.data
          }
          this.counterNumber = response.data
          this.$v.counterNumber.$touch()
          this.isGenerating = false
          this.$emit('numberChanged', this.bookingData)
        })
        .catch((response) => {
          this.isGenerating = false
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    setCounterNumber (value) {
      this.counterNumber = value
      if (this.useShippingReference) {
        this.bookingData.book_parcel_model.Shipment_Reference = this.counterNumber
      } else {
        this.bookingData.book_parcel_model.References[0].Reference_Text = this.counterNumber
      }
      this.bookingData.book_parcel_model.References[0].Reference_Text = this.counterNumber
      this.$v.counterNumber.$touch()
    },
    openScanner () {
      this.$emit('scan')
    },
    touch () {
      this.$v.counterNumber.$touch()
    },
    isInvalid () {
      return this.$v.counterNumber.$invalid
    }
  }
}
</script>

<style lang="scss">

@import '../../variables.scss';
.spl-book-general {
  &__counter {
    display: flex;
    flex-flow: row wrap;
    &__number {
      max-width: 250px;
      margin-right: 20px;
    }
    &__scan button {
      min-width: 110px;
    }
   }
}
@include mobile () {
  .spl-book-general {
    & .spl-button {
      height: 40px;
      font-size: 14px;
    }
    &__counter {
      display: flex;
      &__number, &__number input {
        width: 100%;
        max-width: none;
      }
    }
  }
}
</style>
